<template>
  <div class="view">
    <Title title="ユーザー"/>
    <UserMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import UserMain from '@/components/UserMain'

export default {
  components: {
    Title,
    UserMain
  },
  created: function () {
    this.$store.dispatch('user/retrieveUsers')
  }
}
</script>
